import { render, staticRenderFns } from "./PostingHeaderV2.vue?vue&type=template&id=ee3d8016&scoped=true"
import script from "./PostingHeaderV2.vue?vue&type=script&lang=ts"
export * from "./PostingHeaderV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingHeaderV2.vue?vue&type=style&index=0&id=ee3d8016&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3d8016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee3d8016')) {
      api.createRecord('ee3d8016', component.options)
    } else {
      api.reload('ee3d8016', component.options)
    }
    module.hot.accept("./PostingHeaderV2.vue?vue&type=template&id=ee3d8016&scoped=true", function () {
      api.rerender('ee3d8016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jobboard/PostingHeaderV2.vue"
export default component.exports